import { render, staticRenderFns } from "./alignTop_on.vue?vue&type=template&id=c9ec1dd0&"
import script from "./alignTop_on.vue?vue&type=script&lang=ts&"
export * from "./alignTop_on.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports